
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import moment from 'moment';
window.moment = moment;

import 'moment-timezone';

import 'bootstrap';
import 'popper.js';

import 'bootstrap-datepicker';
import 'jquery-mask-plugin';
require('print-this');
require('fullcalendar');
require('jquery-slimscroll');
require('sticky-kit/dist/sticky-kit.js');
require('jquery-sparkline');

require('./bootstrap');
require('./ie-fix');
require('./custom');
require('./sidebarmenu');

import Vue from "vue";
import Vuex from 'vuex';
import Form from './classes/Form';
window.Form = Form;
import Countries from './classes/Countries';
window.Countries = Countries;

import HospitalStayModule from './store/hospital.module.js';

// Vue Third Party Components

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed);

import 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    hospital: HospitalStayModule,
  },
});

export default store;
// import vSelect from "vue-select"
// Vue.component('v-select', vSelect);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('test-component', require('./components/TestComponent').default);

// App Components
Vue.component('date-picker', require('./components/DatePicker.vue').default);
Vue.component('time-picker', require('./components/TimePicker.vue').default);
Vue.component('activity-list', require('./components/ActivityList.vue').default);
Vue.component('emergency-contacts-tab', require('./components/users/EmergencyContactsTab').default);
Vue.component('loading-card', require('./components/LoadingCard.vue').default);
Vue.component('signature-pad', require('./components/SignaturePad').default);
Vue.component('training', require('./components/Training').default);
Vue.component('quick-search', require('./components/QuickSearch').default);
Vue.component('user-search-dropdown', require('./components/UserSearchDropdown').default);
Vue.component('user-role-search-dropdown', require('./components/UserRoleSearchDropdown').default);
Vue.component('knowledge-center', require('./components/knowledge/KnowledgeCenter').default);
Vue.component('terms-of-use', require('./components/TermsOfUse').default);
Vue.component('claims-fraud-warning-modal', require('./components/ClaimsFraudWarningModal').default);
Vue.component('shift-flag-icons', require('./components/ShiftFlagIcons').default);
Vue.component('bar-chart', require('./components/BarChart').default);
Vue.component('carrier-dropdown', require('./components/CarrierDropdown').default);

// LTCG
Vue.component('utc-time', require('./components/UtcTime').default);
Vue.component('claims-submissions-report', require('./components/LTCG/ClaimsSubmissionsReport').default);


// Client
Vue.component('ltc-shift-approval', require('./components/clients/LtcShiftApproval').default);
Vue.component('client-invoice-history', require('./components/clients/ClientInvoiceHistory').default);
Vue.component('client-revised-invoices', require('./components/clients/ClientRevisedInvoices').default);
Vue.component('client-pending-shifts', require('./components/clients/ClientPendingShifts').default);
Vue.component('client-invoice-details', require('./components/clients/ClientInvoiceDetails').default);
Vue.component('client-invoice-details-print', require('./components/clients/ClientInvoiceDetailsPrint').default);
Vue.component('client-shift', require('./components/clients/ClientShift').default);
Vue.component('client-phone-numbers', require('./components/ClientPhoneNumbers').default);
Vue.component('visit-history', require('./components/clients/VisitHistory').default);
Vue.component('client-addresses', require('./components/ClientAddresses').default);


// Caregiver
Vue.component('caregiver-phone-numbers-tab', require('./components/caregivers/profile/CaregiverPhoneNumbersTab').default);
Vue.component('caregiver-addresses', require('./components/CaregiverAddresses').default);
Vue.component('caregiver-phone-numbers', require('./components/CaregiverPhoneNumbers').default);


// Both Claimant & Provider
Vue.component('user-data-pull', require('./components/UserDataPull').default);


// Admin
Vue.component('admin-audit-log', require('./components/admin/LtcgAuditLog').default);
Vue.component('admin-charges-report', require('./components/admin/AdminChargesReport.vue').default);
Vue.component('admin-deposit-report', require('./components/admin/AdminDepositReport.vue').default);
Vue.component('admin-unsettled-report', require('./components/admin/AdminUnsettledReport.vue').default);
Vue.component('admin-user-list', require('./components/admin/AdminUserList.vue').default);
Vue.component('admin-manual-deposit', require('./components/admin/AdminManualDeposit').default);
Vue.component('admin-pending-charges', require('./components/admin/AdminPendingCharges.vue').default);
Vue.component('admin-pending-deposits', require('./components/admin/AdminPendingDeposits.vue').default);
Vue.component('admin-pending-shifts', require('./components/admin/AdminPendingShifts.vue').default);
Vue.component('admin-transaction', require('./components/admin/AdminTransaction.vue').default);
Vue.component('admin-transactions-report', require('./components/admin/AdminTransactionsReport.vue').default);
Vue.component('authorized-payment-checkbox', require('./components/admin/AuthorizePaymentCheckbox.vue').default);
Vue.component('charge-payment-button', require('./components/admin/ChargePaymentButton.vue').default);
Vue.component('business-create', require('./components/BusinessCreate.vue').default);
Vue.component('business-edit', require('./components/BusinessEdit.vue').default);
Vue.component('business-list', require('./components/BusinessList.vue').default);
Vue.component('business-office-user-list', require('./components/admin/BusinessOfficeUserList').default);
Vue.component('business-office-user-modal', require('./components/admin/BusinessOfficeUserModal').default);

// Office User
Vue.component('admin-dashboard', require('./components/business/Dashboard').default);
Vue.component('audit-table', require('./components/business/AuditTable').default);
Vue.component('business-client', require('./components/business/clients/BusinessClient').default);
Vue.component('client-power-of-attorney', require('./components/business/clients/ClientPowerOfAttorney').default);
Vue.component('edit-office-user', require('./components/users/EditOfficeUser').default);

Vue.component('business-enrollment-queue', require('./components/business/BusinessEnrollmentQueue').default);


Vue.component('business-caregiver', require('./components/business/caregivers/BusinessCaregiver').default);
Vue.component('business-caregiver-preferences-tab', require('./components/business/caregivers/BusinessCaregiverPreferencesTab').default);
Vue.component('business-caregiver-phone-numbers-tab', require('./components/business/caregivers/BusinessCaregiverPhoneNumbersTab').default);
Vue.component('business-certification-expirations', require('./components/BusinessCertificationExpirations.vue').default);
Vue.component('cc-expiration-report', require('./components/business/reports/CreditCardExpirationReport').default);
Vue.component('caregivers-missing-bank-accounts', require('./components/business/reports/CaregiversMissingBankAccounts').default);
Vue.component('business-care-risk-report', require('./components/business/reports/CareRiskReport').default);
Vue.component('business-fraud-risk-report', require('./components/business/reports/FraudRiskReport').default);
Vue.component('business-client-caregivers-report', require('./components/BusinessClientCaregiversReport.vue').default);
Vue.component('business-enrollment-report', require('./components/business/reports/BusinessEnrollmentReport').default);
Vue.component('business-inactivity-report', require('./components/business/reports/BusinessInactivityReport').default);
Vue.component('business-invoiced-user-list-report', require('./components/business/reports/BusinessInvoicedUserListReport.vue').default);
Vue.component('business-staff-call-log-report', require('./components/business/reports/BusinessStaffCallLogReport.vue').default);
Vue.component('business-paired-report', require('./components/business/reports/BusinessPairedReport').default);
Vue.component('business-status-report', require('./components/business/reports/BusinessStatusReport').default);
Vue.component('business-deposit-history', require('./components/BusinessDepositHistory.vue').default);
Vue.component('business-exception', require('./components/BusinessException.vue').default);
Vue.component('business-exception-list', require('./components/BusinessExceptionList.vue').default);
Vue.component('business-issue-modal', require('./components/BusinessIssueModal.vue').default);
Vue.component('business-medicaid-report', require('./components/business/reports/MedicaidReport.vue').default);
Vue.component('business-payment-history', require('./components/BusinessPaymentHistory.vue').default);
Vue.component('business-overtime-report', require('./components/BusinessOvertimeReport.vue').default);
Vue.component('business-reconciliation-report', require('./components/BusinessReconciliationReport').default);
Vue.component('business-shift', require('./components/BusinessShift.vue').default);
Vue.component('shift-hospital-stay-input', require('./components/ShiftHospitalStayInput.vue').default);
Vue.component('shift-hospital-stay-input-x', require('./components/ShiftHospitalStayInputX.vue').default);
Vue.component('business-shift-exports', require('./components/business/exports/BusinessShiftExports').default);
Vue.component('business-shift-report', require('./components/BusinessShiftReport.vue').default);
Vue.component('business-shift-flags-report', require('./components/BusinessShiftFlagsReport.vue').default);
Vue.component('business-shift-details-modal', require('./components/modals/ShiftDetailsModal').default);
Vue.component('business-scheduled-payments', require('./components/business/reports/ScheduledPaymentsReport.vue').default);
// Vue.component('business-scheduled-vs-actual', require('./components/BusinessScheduledVsActual.vue').default);
// Vue.component('business-convert-schedule-modal', require('./components/BusinessConvertScheduleModal.vue').default);
Vue.component('business-send-blast', require('./components/business/BusinessSendBlast').default);
Vue.component('business-schedule', require('./components/business/schedule/BusinessSchedule.vue').default);
Vue.component('business-schedule-modal', require('./components/business/schedule/BusinessScheduleModal').default);
Vue.component('business-settings', require('./components/business/BusinessSettings.vue').default);
Vue.component('business-transaction', require('./components/BusinessTransaction.vue').default);
Vue.component('business-clients-onboarded', require('./components/business/reports/ClientOnboarded').default);
Vue.component('business-caregivers-onboarded', require('./components/business/reports/CaregiverOnboarded').default);
Vue.component('business-caregiver-misc-tab', require('./components/business/caregivers/CaregiverMiscTab').default);
Vue.component('bulk-delete-schedule-modal', require('./components/business/schedule/BulkDeleteScheduleModal').default);
Vue.component('business-provider-feedback-report', require('./components/business/reports/ProviderFeedback').default);
Vue.component('business-frequent-offenders-report', require('./components/business/reports/FrequentOffenders').default);
Vue.component('business-carrier-savings', require('./components/business/reports/CarrierSavings').default);
Vue.component('enrollment-queue-report', require('./components/business/reports/EnrollmentQueueReport').default);
Vue.component('submitted-invoices-report', require('./components/business/reports/SubmittedInvoicesReport').default);
Vue.component('decommission-modal', require('./components/business/DecommissionModal').default);
Vue.component('business-evv-report', require('./components/business/reports/EvvReport').default);
Vue.component('business-falls-report', require('./components/business/reports/FallsReport').default);
Vue.component('business-condition-report', require('./components/business/reports/ConditionReport').default);
Vue.component('business-time-to-enroll-report', require('./components/business/reports/TimeToEnroll').default);
Vue.component('business-duplicate-users-report', require('./components/business/reports/DuplicateUsersReport').default);
Vue.component('daily-imports-report', require('./components/business/reports/DailyImportsReport').default);

Vue.component('impersonate-list', require('./components/business/ImpersonateList').default);

Vue.component('notes-tab', require('./components/notes/NotesTab').default);

Vue.component('care-plan-edit', require('./components/CarePlanEdit.vue').default);
Vue.component('care-plan-list', require('./components/CarePlanList.vue').default);

Vue.component('caregiver-business-shift', require('./components/CaregiverBusinessShift.vue').default);
Vue.component('caregiver-create', require('./components/CaregiverCreate.vue').default);
Vue.component('caregiver-edit', require('./components/CaregiverEdit.vue').default);
Vue.component('caregiver-license-list', require('./components/CaregiverLicenseList.vue').default);
Vue.component('caregiver-license-modal', require('./components/CaregiverLicenseModal.vue').default);
Vue.component('caregiver-list', require('./components/CaregiverList.vue').default);
Vue.component('caregiver-schedule', require('./components/CaregiverSchedule.vue').default);
Vue.component('caregiver-invoice-history', require('./components/caregivers/CaregiverInvoiceHistory').default);
// Vue.component('caregiver-payment-details', require('./components/caregivers/CaregiverPaymentDetails').default);
Vue.component('caregiver-client-list', require('./components/caregivers/ClientList').default);
Vue.component('caregiver-training', require('./components/caregivers/CaregiverTraining').default);
Vue.component('caregiver-contact-form', require('./components/caregivers/ContactForm').default);
Vue.component('caregiver-visit-history', require('./components/caregivers/CaregiverVisitHistory').default);

Vue.component('caregiver-distance-report', require('./components/CaregiverDistanceReport.vue').default);

Vue.component('change-password', require('./components/ChangePassword.vue').default);
Vue.component('change-email', require('./components/ChangeEmail.vue').default);
Vue.component('show-email', require('./components/ShowEmail.vue').default);
Vue.component('manage-communications', require('./components/ManageCommunications.vue').default);
Vue.component('manage-dob', require('./components/ManageDob.vue').default);

Vue.component('clock-in', require('./components/ClockIn.vue').default);
Vue.component('clock-out', require('./components/ClockOut.vue').default);

Vue.component('caregiver-enrollment', require('./components/CaregiverEnrollment.vue').default);
Vue.component('client-enrollment', require('./components/ClientEnrollment.vue').default);

Vue.component('carrier-manager-list', require('./components/business/carrier_managers/List.vue').default);
Vue.component('carrier-manager-create', require('./components/business/carrier_managers/Create.vue').default);


Vue.component('business-client-caregivers', require('./components/business/clients/ClientCaregivers.vue').default);
Vue.component('client-edit', require('./components/ClientEdit.vue').default);
Vue.component('client-list', require('./components/ClientList.vue').default);
Vue.component('client-profile', require('./components/ClientProfile.vue').default);
Vue.component('office-user-profile', require('./components/OfficeUserProfile.vue').default);
Vue.component('carrier-manager-profile', require('./components/CarrierManagerProfile.vue').default);
Vue.component('client-statements-tab', require('./components/business/clients/ClientStatementsTab').default);
Vue.component('clients-without-emails-report', require('./components/business/reports/ClientsWithoutEmailsReport').default);
Vue.component('client-caregiver-list', require('./components/clients/CaregiverList').default);


Vue.component('credit-card-form', require('./components/CreditCardForm.vue').default);
Vue.component('bank-account-form', require('./components/BankAccountForm.vue').default);

Vue.component('dashboard-metric', require('./components/DashboardMetric.vue').default);

Vue.component('full-calendar', require('./components/FullCalendar.vue').default);

Vue.component('input-help', require('./components/InputHelp.vue').default);
Vue.component('input-template-vars', require('./components/InputTemplateVars.vue').default);

Vue.component('message', require('./components/Message.vue').default);
Vue.component('mfa-configure', require('./components/MfaConfigure.vue').default);
Vue.component('mfa-configure-collapsible', require('./components/MfaConfigureCollapsible.vue').default);

Vue.component('payment-method', require('./components/PaymentMethod.vue').default);
Vue.component('payment-method-provider', require('./components/PaymentMethodProvider.vue').default);

Vue.component('reset-password-modal', require('./components/ResetPasswordModal.vue').default);
Vue.component('send-welcome-email-modal', require('./components/SendWelcomeEmailModal.vue').default);

Vue.component('shift-history', require('./components/ShiftHistory.vue').default);

Vue.component('system-notifications', require('./components/SystemNotifications.vue').default);

Vue.component('phone-number', require('./components/PhoneNumber.vue').default.default);
Vue.component('user-address', require('./components/UserAddress.vue').default);
Vue.component('document-list', require('./components/DocumentList.vue').default);
// notes
Vue.component('note-create', require('./components/notes/NoteCreate').default);
Vue.component('note-list', require('./components/notes/NoteList').default);
Vue.component('note-edit', require('./components/notes/NoteEdit').default);
// caregiver applications
Vue.component('caregiver-application-create', require('./components/caregivers/CaregiverApplicationCreate').default);
Vue.component('caregiver-application-list', require('./components/caregivers/CaregiverApplicationList').default);
Vue.component('caregiver-application', require('./components/caregivers/CaregiverApplication').default);

Vue.component('mask-input', require('./components/MaskInput').default);
Vue.component('manual-shift-wizard', require('./components/ManualShiftWizard').default);

Vue.component('message-thread', require('./components/MessageThread').default);
Vue.component('message-list', require('./components/MessageList').default);
Vue.component('business-message-list', require('./components/business/MessageList').default);
Vue.component('business-compose-message', require('./components/business/ComposeMessage').default);
Vue.component('knowledge-manager', require('./components/knowledge/KnowledgeManager').default);
Vue.component('knowledge-editor', require('./components/knowledge/KnowledgeEditor').default);
Vue.component('knowledge-item', require('./components/knowledge/KnowledgeItem').default);

Vue.component('support-call', require('./components/business/support/SupportCall').default);
Vue.component('support-options', require('./components/business/support/SupportOptions').default);
Vue.component('support-call-list', require('./components/business/support/SupportCallList').default);
Vue.component('business-carrier-list', require('./components/business/BusinessCarrierList').default);
Vue.component('business-carrier-form', require('./components/business/BusinessCarrierForm').default);
Vue.component('business-carrier-logo-editor', require('./components/business/BusinessCarrierLogoEditor').default);

Vue.component('carrier-parents-dropdown', require("./components/CarrierParentsDropdown.vue").default);

Vue.component('text-thread', require('./components/twoWayText/TextThread').default);
Vue.component('text-message-manager', require('./components/twoWayText/MessageManager').default);
Vue.component('text-blast-manager', require('./components/twoWayText/BlastManager').default);
Vue.component('text-template-manager', require('./components/twoWayText/TemplateManager').default);
Vue.component('text-template-variable-manager', require('./components/twoWayText/VariableManager').default);

Vue.component('true-up-index', require('./components/ipSyncProject/UpdTrueUpIndex').default);
Vue.component('ip-sync-files-index', require('./components/ipSyncProject/IpSyncIndex').default);
Vue.component('pending-ftp-files', require('./components/ipSyncProject/PendingFtpFiles').default);
Vue.component('download-ftp-files', require('./components/ipSyncProject/DownloadFtpFiles').default);
Vue.component('parking-lot-index', require('./components/ipSyncProject/ParkingLotIndex').default);
Vue.component('parking-lot-show', require('./components/ipSyncProject/ParkingLotShow').default);

Vue.component('upd-fuzzy-match', require('./components/ipSyncProject/UpdFuzzyMatch').default);
Vue.component('upd-create-provider', require('./components/ipSyncProject/UpdCreateProvider').default);
Vue.component('upd-update-provider', require('./components/ipSyncProject/UpdUpdateProvider').default);
Vue.component('upd-provider-interface', require('./components/ipSyncProject/UpdProviderInterface').default);
Vue.component('upd-provider-card', require('./components/ipSyncProject/UpdProviderCard').default);

Vue.component('claimant-list', require('./components/business/carrier_managers/ClaimantList').default);
Vue.component('provider-list', require('./components/business/carrier_managers/ProviderList').default);

// Vue.component('business-shift-details-modal', require('./components/modals/ShiftDetailsModal').default);
Vue.component('shift-map', require('./components/ShiftMap').default);

Vue.component( 'client-support-call', require( './components/business/clients/ClientSupportCall' ) );
Vue.component( 'call-logs', require( './components/CallLogs' ) );
Vue.component('privacy',require('./components/Privacy.vue').default);
Vue.filter('date', value => {
    return moment.utc(value).local().format('L');
});

Vue.filter('datetime', value => {
    return moment.utc(value).local().format('L LT');
});

Vue.filter('capitalize', value => {
    if (! value && value !== 0) {
        return '';
    }

    return value.toString().charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('nl2br', value => {
    return value.toString().replace(/(?:\r\n|\r|\n)/g, '<br />');
});

Vue.filter('undo_snake_case', value => {

    return value.toString().split( '_' ).join( ' ' );
});

const app = new Vue({
    el: '#main-wrapper',
    store : store
});
require('./alerts');
